import React, { useState, useEffect } from "react";
import { DateTime } from "luxon";
import "./CountdownClock.scss";

export default function CountdownClock({ event, match_update }) {
  const [timeLeft, setTimeLeft] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
  });

  useEffect(() => {
    setTimeout(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000);
  });

  let startDateTime = null;

  const { start_datetime } = match_update || {};

  if (start_datetime) {
    startDateTime = DateTime.fromISO(start_datetime);
  } else {
    return <div className="countdown-clock">No start time provided.</div>;
  }

  function calculateTimeLeft() {
    let timeUntilStart = {
      days: 0,
      hours: 0,
      minutes: 0,
      seconds: 0,
    };

    if (!startDateTime) {
      return null;
    }

    timeUntilStart = startDateTime
      .diffNow(["days", "hours", "minutes", "seconds"])
      .toObject();
    timeUntilStart.seconds = Number(timeUntilStart.seconds.toFixed(0));

    if (timeUntilStart.days < 1) {
      timeUntilStart.days = null;
    } else {
      timeUntilStart.days = timeUntilStart.days + "d ";
    }

    if (timeUntilStart.hours < 10) {
      timeUntilStart.hours = "0" + timeUntilStart.hours;
    }

    if (timeUntilStart.minutes < 10) {
      timeUntilStart.minutes = "0" + timeUntilStart.minutes;
    }

    if (timeUntilStart.seconds < 10) {
      timeUntilStart.seconds = "0" + timeUntilStart.seconds;
    }

    if (timeUntilStart.seconds === 60) {
      timeUntilStart.seconds = "00";
    }

    return timeUntilStart;
  }

  const { event_description } = event;

  if (startDateTime < DateTime.now()) {
    return (
      <div className="countdown-clock">
        Match was scheduled to start at{" "}
        {startDateTime.toLocaleString(DateTime.DATETIME_SHORT)}
      </div>
    );
  }

  if (!timeLeft) {
    return (
      <div className="countdown-clock">
        <div>Match Scheduled</div>
        <div>{event_description}</div>
      </div>
    );
  }

  return (
    <div className="countdown-clock">
      <div>Match Scheduled</div>
      <div className="clock">
        {timeLeft.days}
        {timeLeft.hours + ":" + timeLeft.minutes + ":" + timeLeft.seconds}
      </div>
      <div>{event_description}</div>
    </div>
  );
}
